import { render } from "./CadFinancasReceitas.vue?vue&type=template&id=34f985b3"
import script from "./CadFinancasReceitas.vue?vue&type=script&lang=js"
export * from "./CadFinancasReceitas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__